import { Helmet } from "react-helmet";
import imgOne from "../images/Section-2/section-two-img-one.webp";
import imgTwo from "../images/Section-2/section-two-img-two.webp";
import imgThree from "../images/Section-2/section-two-img-three.webp";
import chatIcon from "../images/Section-2/Chat Bubble Typing Oval.webp";
import graphIcon from "../images/Section-2/Graph Bar Increase.webp";
import backgroundImg from "../images/Section-1/background.webp";

export default function SectionTwo() {
  return (
    <div className="w-full relative overflow-hidden font-aldrich">
      <Helmet>
        <title>Why Top Doctors Trust DUMOSH</title>
        <meta
          name="description"
          content="Discover why top doctors trust DUMOSH for their digital marketing and business growth needs."
        />
        <meta
          name="keywords"
          content="digital marketing, healthcare marketing, doctor marketing, SEO, branding, advertising"
        />
        <meta property="og:title" content="Why Top Doctors Trust DUMOSH" />
        <meta
          property="og:description"
          content="Discover why top doctors trust DUMOSH for their digital marketing and business growth needs."
        />
        <meta property="og:image" content={imgOne} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://yourwebsite.com/section-two" />

        <link rel="preload" as="image" href={imgOne} />
        <link rel="preload" as="image" href={imgTwo} />
        <link rel="preload" as="image" href={imgThree} />
        <link rel="preload" as="image" href={chatIcon} />
        <link rel="preload" as="image" href={graphIcon} />
        <link rel="preload" as="image" href={backgroundImg} />
      </Helmet>
      {/* Main Section */}
      <div className="max-w-2xl md:max-w-full lg:mx-[2rem]  px-2 flex flex-col space-y-8 bg-black ">
        {/* First Row */}
        <div className="grid grid-cols-1 gap-8 items-center">
          <div className="flex flex-col space-y-4">
            <div className="m-2">
              <div className="flex flex-row justify-start items-center gap-4 my-4 whitespace-nowrap w-full">
                <h2 className="text-xl md:text-2xl lg:text-4xl xl:text-5xl text-left text-white">
                  Why Top Doctors Trust
                  <span className="text-xl md:text-2xl lg:text-4xl xl:text-5xl text-left text-white pl-1 font-bold font-impact">
                    DUMOSH
                  </span>
                  <span className="text-xl md:text-2xl lg:text-4xl xl:text-5xl text-left text-[#FF3E3E]">
                    .
                  </span>
                </h2>
              </div>
              <p className="text-base md:text-xl lg:text-3xl xl:text-4xl text-left text-white">
                Your medical expertise took years to master.
              </p>
              <p className="text-base md:text-xl lg:text-3xl xl:text-4xl text-left text-white">
                Your marketing shouldn't.
              </p>
            </div>
          </div>
          <div className="flex justify-center md:justify-end w-full overflow-hidden">
            <img
              src={imgOne}
              alt="Medical Illustration"
              className="w-full max-w-none h-auto max-h-[45rem] object-cover"
            />
          </div>
        </div>

        {/* Second Row */}
        <div className="flex flex-col justify-center items-center">
          <p className="text-base md:text-xl lg:text-3xl xl:text-4xl  lg:px-4 text-left text-white">
            Stand Out with our Premium Services, Everything you need for your
            Business Growth, with;
          </p>
          {/* Mobile-Tab View */}
          {/* First */}
          <div className="lg:hidden flex flex-col justify-center items-center w-full">
            <div className="w-full grid grid-cols-3 gap-2">
              <div className="flex flex-col justify-center p-4 bg-white col-span-2 w-full">
                <p className="text-xl md:text-2xl text-left text-black">
                  Digital
                </p>
                <p className="text-xl md:text-2xl text-left text-black">
                  Marketing
                </p>
                <p className="text-xl md:text-2xl text-left text-black">
                  &amp; Tele Calling
                </p>
              </div>
              <div
                className="col-span-1 w-full h-[130px] bg-cover bg-no-repeat"
                style={{
                  backgroundImage: `url(${imgTwo})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div
              className="flex flex-col justify-center p-6  w-full h-[135px]  border-2 my-2 bg-cover bg-no-repeat"
              style={{
                backgroundImage: `url(${backgroundImg})`,
                backgroundPosition: "center",
              }}
            >
              <p className="text-xl md:text-2xl text-left text-white">
                Google Ads,
              </p>
              <p className="text-xl md:text-2xl text-left text-white">
                Google My Business
              </p>
              <p className="text-xl md:text-2xl text-left text-white">
                Management
              </p>
              <p className="text-xl md:text-2xl text-left text-white">
                Facebook &amp; Instagram Ads
              </p>
            </div>
          </div>
          {/* Second */}
          <div className="lg:hidden flex flex-col justify-center items-center w-full">
            <div className="w-full grid grid-cols-3 gap-2">
              <div className="flex flex-col justify-center p-4 bg-[#D9D9D9] col-span-2 w-full">
                <p className="text-xl md:text-2xl text-left text-black">
                  Digital
                </p>
                <p className="text-xl md:text-2xl text-left text-black">
                  Creatives &amp;
                </p>
                <p className="text-xl md:text-2xl text-left text-black">
                  Brand Videos
                </p>
              </div>
              <div
                className="col-span-1 w-full h-[130px] bg-cover bg-no-repeat"
                style={{
                  backgroundImage: `url(${imgThree})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div
              className="flex flex-col justify-center p-4  w-full h-[120px] border-2 my-2 bg-cover bg-no-repeat"
              style={{
                backgroundImage: `url(${backgroundImg})`,
                backgroundPosition: "center",
              }}
            >
              <p className="text-xl md:text-2xl text-left text-white">
                Creative Content,
              </p>
              <p className="text-xl md:text-2xl text-left text-white">
                SEO &amp;
              </p>
              <p className="text-xl md:text-2xl text-left text-white">
                Blogging
              </p>
            </div>
          </div>
          {/* Third */}
          <div className="lg:hidden flex flex-col justify-center items-center w-full">
            <div className="w-full grid grid-cols-5 gap-2">
              <div className="flex flex-rows justify-evenly items-center p-4 bg-white col-span-2 w-full">
                <div className="mt-2">
                  <p className="text-xl md:text-2xl text-left text-black">
                    Live Chat
                  </p>
                </div>
                <div className="flex items-center justify-center">
                  <img
                    src={chatIcon}
                    alt="chatIcon"
                    className="w-full h-auto md:w-15 md:h-18 object-contain"
                  />
                </div>
              </div>
              <div className="flex flex-rows justify-evenly items-center p-4 bg-white col-span-3 w-full">
                <div className="mt-2">
                  <p className="text-xl md:text-2xl text-left text-black">
                    Reporting &amp; CRM
                  </p>
                </div>
                <div className="flex items-center justify-center">
                  <img
                    src={graphIcon}
                    alt="graphIcon"
                    className="w-full h-auto md:w-15 md:h-18 object-contain"
                  />
                </div>
              </div>
            </div>
            <div
              className="flex flex-col justify-center p-4  w-full h-[120px] border-2 my-2 bg-cover bg-no-repeat"
              style={{
                backgroundImage: `url(${backgroundImg})`,
                backgroundPosition: "center",
              }}
            >
              <p className="text-xl md:text-2xl text-left text-white">
                Smart Scheduling &amp;
              </p>
              <p className="text-xl md:text-2xl text-left text-white">
                Follow - Ups
              </p>
            </div>
          </div>

          {/* Laptop-Desktop View */}

          <div className="w-full hidden lg:grid lg:grid-cols-3 p-2 mb-2">
            <div className="w-full flex flex-col justify-center items-center col-span-2 p-2">
              <div className="w-full flex flex-row justify-between items-start space-x-2 h-[150px] mb-2">
                <div className="flex flex-col justify-center p-4 h-[150px] bg-white w-full ">
                  <p className="lg:text-3xl xl:text-4xl text-left text-black">
                    Digital
                  </p>
                  <p className="lg:text-3xl xl:text-4xl text-left text-black">
                    Marketing
                  </p>
                  <p className="lg:text-3xl xl:text-4xl text-left text-black">
                    &amp; Tele Calling
                  </p>
                </div>
                <div className="flex flex-col justify-center p-4 h-[150px] bg-white w-full">
                  <p className="lg:text-3xl xl:text-4xl text-left text-black">
                    Creative
                  </p>
                  <p className="lg:text-3xl xl:text-4xl text-left text-black">
                    Content, SEO
                  </p>
                  <p className="lg:text-3xl xl:text-4xl text-left text-black">
                    &amp; Blogging
                  </p>
                </div>
              </div>

              <div
                className="flex flex-col justify-center p-2 w-full h-[200px]  border-2 bg-cover bg-no-repeat"
                style={{
                  backgroundImage: `url(${backgroundImg})`,
                  backgroundPosition: "center",
                }}
              >
                <p className="lg:text-3xl xl:text-4xl text-left text-white">
                  Google Ads,
                </p>
                <p className="lg:text-3xl xl:text-4xl text-left text-white">
                  Google My Business
                </p>
                <p className="lg:text-3xl xl:text-4xl text-left text-white">
                  Management
                </p>
                <p className="lg:text-3xl xl:text-4xl text-left text-white">
                  Facebook &amp; Instagram Ads
                </p>
              </div>
            </div>

            <div className="w-full p-2">
              <div
                className="col-span-1 w-full h-[356px] bg-cover bg-no-repeat"
                style={{
                  backgroundImage: `url(${imgTwo})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </div>

          <div className="w-full hidden lg:grid lg:grid-cols-3 p-2 mb-10">
            <div className="w-full p-2">
              <div
                className="col-span-1 w-full h-[292px] bg-cover bg-no-repeat"
                style={{
                  backgroundImage: `url(${imgThree})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>

            <div className="w-full flex flex-col justify-start items-center col-span-2">
              <div className="w-full grid grid-cols-5 gap-2 m-2">
                <div className="flex flex-rows justify-evenly items-center p-4 bg-white col-span-2 w-full">
                  <div className="mt-2">
                    <p className="lg:text-3xl xl:text-4xl text-left text-black">
                      Live Chat
                    </p>
                  </div>
                  <div className="flex items-center justify-center">
                    <img
                      src={chatIcon}
                      alt="chatIcon"
                      className="w-full h-auto md:w-15 md:h-18 object-contain"
                    />
                  </div>
                </div>
                <div className="flex flex-rows justify-evenly items-center p-4 bg-white col-span-3 w-full">
                  <div className="mt-2">
                    <p className="lg:text-3xl xl:text-4xl text-left text-black">
                      Reporting &amp; CRM
                    </p>
                  </div>
                  <div className="flex items-center justify-center">
                    <img
                      src={graphIcon}
                      alt="graphIcon"
                      className="w-full h-auto md:w-15 md:h-18 object-contain"
                    />
                  </div>
                </div>
              </div>

              <div className="w-full flex flex-row justify-between items-start space-x-2 h-[150px] m-2">
                <div className="flex flex-col justify-center p-4 h-[200px] bg-white w-full ">
                  <p className="lg:text-3xl xl:text-4xl text-left text-black">
                    Digital
                  </p>
                  <p className="lg:text-3xl xl:text-4xl text-left text-black">
                    Creatives &amp;
                  </p>
                  <p className="lg:text-3xl xl:text-4xl text-left text-black">
                    Brand Videos
                  </p>
                </div>

                <div
                  className="flex flex-col justify-center p-2 w-full h-[200px]  border-2 bg-cover bg-no-repeat"
                  style={{
                    backgroundImage: `url(${backgroundImg})`,
                    backgroundPosition: "center",
                  }}
                >
                  <p className="lg:text-3xl xl:text-4xl text-left text-white">
                    Smart
                  </p>
                  <p className="lg:text-3xl xl:text-4xl text-left text-white">
                    Scheduling &amp;
                  </p>
                  <p className="lg:text-3xl xl:text-4xl text-left text-white">
                    Management
                  </p>
                  <p className="lg:text-3xl xl:text-4xl text-left text-white">
                    Follow - Ups
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
